import {
  Language,
  Operations,
  UserStatus,
  UserWithRelations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kUserGroups } from "./user-groups";

export const kUsers: (UserWithRelations & Operations)[] = [
  {
    id: "2d0285ef-cff4-46e6-800c-2824490f6cc9",
    firstName: "Erin",
    infix: "",
    lastName: "Fowler",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-05T01:30:57.5757",
    email: "erinfowler@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "51175149-0c75-4410-8531-2235a436c20a",
    firstName: "Juliana",
    infix: "",
    lastName: "Howell",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-01T03:40:02.022",
    email: "julianahowell@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d4d07b71-7330-4051-9fc1-8e7305dd231d",
    firstName: "Kaye",
    infix: "",
    lastName: "Romero",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-05-23T11:35:10.1010",
    email: "kayeromero@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d3a0b197-eecc-4cfc-9b6f-5dec27b26b07",
    firstName: "Simpson",
    infix: "",
    lastName: "Mclaughlin",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-12-13T10:10:08.088",
    email: "simpsonmclaughlin@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "39b2c2fb-fbf4-472f-900a-86b836a64c79",
    firstName: "Lourdes",
    infix: "",
    lastName: "Atkins",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-12T03:58:14.1414",
    email: "lourdesatkins@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "663b0278-f3b9-4cd0-bf10-fa1cd92bfeca",
    firstName: "Queen",
    infix: "",
    lastName: "Reeves",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-05-18T07:10:48.4848",
    email: "queenreeves@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e53737f8-8baa-41ef-88ef-4e0d6d62a215",
    firstName: "Henry",
    infix: "",
    lastName: "Holman",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-04-25T10:32:44.4444",
    email: "henryholman@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9ee2279b-42d8-4f3f-8056-c27d8d94fd8e",
    firstName: "Suzanne",
    infix: "",
    lastName: "Frost",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-03-13T05:35:48.4848",
    email: "suzannefrost@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "fd6de5bb-6b09-4cbb-8a03-56814579417f",
    firstName: "Sheryl",
    infix: "",
    lastName: "Sims",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-01-15T12:43:21.2121",
    email: "sherylsims@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5d64f44f-6e89-4e96-8d75-a577b09536d5",
    firstName: "Georgina",
    infix: "",
    lastName: "Hernandez",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-08-22T07:27:17.1717",
    email: "georginahernandez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "17726ffe-2454-4125-a080-f92ac3f8fa5c",
    firstName: "Benton",
    infix: "",
    lastName: "Villarreal",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2023-07-05T07:06:31.3131",
    email: "bentonvillarreal@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0b9719fb-168f-4bcb-ad6a-8aeef39a2e99",
    firstName: "Summer",
    infix: "",
    lastName: "Workman",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-02T02:29:54.5454",
    email: "summerworkman@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 1),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c3f72f6a-8898-497a-aae1-a9a79864b35a",
    firstName: "Bailey",
    infix: "",
    lastName: "Cunningham",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-11-21T12:48:22.2222",
    email: "baileycunningham@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0c504ebd-8bc3-4dc1-b4b0-5301ce9370cd",
    firstName: "Gutierrez",
    infix: "",
    lastName: "Henson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-02-07T06:51:50.5050",
    email: "gutierrezhenson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "2a5a21e1-abcc-474f-97f9-a7d239fb446d",
    firstName: "Marissa",
    infix: "",
    lastName: "Joseph",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-01-14T10:12:15.1515",
    email: "marissajoseph@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c4950e6c-dbcf-4a63-b1d2-eb3e41767a01",
    firstName: "Koch",
    infix: "",
    lastName: "Boone",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-29T08:39:07.077",
    email: "kochboone@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "2cc5d199-7d41-450b-add4-0fdf8f4240bf",
    firstName: "Maynard",
    infix: "",
    lastName: "Miranda",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-01-09T08:15:37.3737",
    email: "maynardmiranda@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "b44f5861-b3c3-4804-8ad4-484fcad50b93",
    firstName: "Alvarez",
    infix: "",
    lastName: "England",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-03-06T04:29:42.4242",
    email: "alvarezengland@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 1),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f93e5c19-375f-4b31-abdb-249f035c4259",
    firstName: "York",
    infix: "",
    lastName: "Garrison",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-09T07:57:06.066",
    email: "yorkgarrison@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7ddf3531-68e7-43ae-a274-75645c5ffcf0",
    firstName: "Alberta",
    infix: "",
    lastName: "Sanchez",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-05-21T01:47:14.1414",
    email: "albertasanchez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "61fc802a-5e23-4382-9c1f-0183d5d67a1a",
    firstName: "Bowers",
    infix: "",
    lastName: "Burt",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-08-21T08:50:35.3535",
    email: "bowersburt@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "48deca53-9be7-44e2-b478-c328e23804cd",
    firstName: "Cortez",
    infix: "",
    lastName: "Gallegos",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-11-18T04:32:24.2424",
    email: "cortezgallegos@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e241d454-e4e9-4f52-8dfc-facc330f134b",
    firstName: "Patrick",
    infix: "",
    lastName: "Barker",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-03-24T09:30:56.5656",
    email: "patrickbarker@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "084a9c0c-343a-4fe4-8bd2-a3f237eb6ddc",
    firstName: "Wilder",
    infix: "",
    lastName: "Beasley",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-03-02T07:03:30.3030",
    email: "wilderbeasley@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6847a67e-38b6-4463-95a0-df5ea67d976d",
    firstName: "Penny",
    infix: "",
    lastName: "Berry",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-04-22T11:51:25.2525",
    email: "pennyberry@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3edbb6e7-98c6-48e4-8718-c62208668e1d",
    firstName: "Elise",
    infix: "",
    lastName: "Buchanan",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-07-28T02:45:29.2929",
    email: "elisebuchanan@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "486585ab-ffd7-46c5-915b-c0dff8ef99fa",
    firstName: "Winters",
    infix: "",
    lastName: "Aguilar",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-07-19T08:11:29.2929",
    email: "wintersaguilar@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1b7ac624-da2b-4fe2-9606-b84497ab6edd",
    firstName: "Workman",
    infix: "",
    lastName: "Crane",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-27T07:59:04.044",
    email: "workmancrane@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "723df848-dc1a-410b-b36f-e5b4b6c2f1c5",
    firstName: "Matilda",
    infix: "",
    lastName: "Santiago",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-03-18T05:47:36.3636",
    email: "matildasantiago@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "de4140a6-c9c3-4007-bbed-b6769cc159a5",
    firstName: "Veronica",
    infix: "",
    lastName: "Adkins",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-11-20T10:51:19.1919",
    email: "veronicaadkins@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "62764caa-77ca-42ea-911b-4c2d10151ec4",
    firstName: "Burks",
    infix: "",
    lastName: "Dillon",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-09-17T04:57:49.4949",
    email: "burksdillon@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "fc0b1fdc-3ca6-4de2-b33e-fcde85866d14",
    firstName: "Salazar",
    infix: "",
    lastName: "Fletcher",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-22T08:27:30.3030",
    email: "salazarfletcher@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d800c54b-5f1c-4c9d-9ce2-751abb3dd161",
    firstName: "Margret",
    infix: "",
    lastName: "Parker",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-03-28T11:58:34.3434",
    email: "margretparker@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5cc94234-fdf8-4488-ba50-fdac5378b300",
    firstName: "Rios",
    infix: "",
    lastName: "Benson",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-10-20T03:56:25.2525",
    email: "riosbenson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c119205d-415e-40c1-8974-c36a9628582c",
    firstName: "Whitley",
    infix: "",
    lastName: "Pace",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-02-05T10:53:45.4545",
    email: "whitleypace@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "426b0698-cf24-411c-961c-32ab66fa5c43",
    firstName: "Stevenson",
    infix: "",
    lastName: "Pratt",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-09-04T03:15:25.2525",
    email: "stevensonpratt@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bad2a647-2128-418a-930f-632333df7a7f",
    firstName: "Bean",
    infix: "",
    lastName: "Roth",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-09-03T04:18:53.5353",
    email: "beanroth@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8eac95d4-31e0-4589-a329-adfbd9610dc7",
    firstName: "Rosanna",
    infix: "",
    lastName: "Jefferson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-13T09:04:37.3737",
    email: "rosannajefferson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e16ce5eb-099f-46b3-92a7-b04647675a77",
    firstName: "Olivia",
    infix: "",
    lastName: "Hyde",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-03-08T03:57:06.066",
    email: "oliviahyde@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "53666623-c9a5-4808-9826-fbe976595f25",
    firstName: "Lea",
    infix: "",
    lastName: "Joyce",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-04-25T09:55:09.099",
    email: "leajoyce@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "396dfa80-737d-4ee2-8725-f784860cb8ce",
    firstName: "Diane",
    infix: "",
    lastName: "Beard",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-12T02:29:10.1010",
    email: "dianebeard@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f358f3b4-2bff-438a-8b44-cc9f84ef4062",
    firstName: "Coleman",
    infix: "",
    lastName: "Hodge",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-02-28T07:50:02.022",
    email: "colemanhodge@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0723857f-49cc-422a-aebc-1615640bb6ab",
    firstName: "Nielsen",
    infix: "",
    lastName: "Green",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-05-31T08:18:08.088",
    email: "nielsengreen@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4871ceb1-b34a-48e4-b688-3bddfb855acd",
    firstName: "Renee",
    infix: "",
    lastName: "Griffith",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-08-11T06:20:03.033",
    email: "reneegriffith@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9f0826b7-5286-4426-8d6d-8250439c3bdb",
    firstName: "West",
    infix: "",
    lastName: "Holland",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-03-26T05:02:20.2020",
    email: "westholland@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6507aea4-048e-4f87-817c-6a63c2fa1e2e",
    firstName: "Carrillo",
    infix: "",
    lastName: "Sellers",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-06T12:59:06.066",
    email: "carrillosellers@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "062f1d72-ff53-4792-9978-3fecec2724c3",
    firstName: "Kara",
    infix: "",
    lastName: "Clarke",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-19T05:45:13.1313",
    email: "karaclarke@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "60be75ee-f624-4c7b-9852-ee2b6f208234",
    firstName: "Elliott",
    infix: "",
    lastName: "Benjamin",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-10-21T06:42:28.2828",
    email: "elliottbenjamin@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 1),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "49a87bea-19d2-4e2d-bda3-142c0cde0051",
    firstName: "Lolita",
    infix: "",
    lastName: "Oneill",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-20T12:37:00.000",
    email: "lolitaoneill@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "aa65790f-4900-4d01-9d56-f82876ed0579",
    firstName: "Keri",
    infix: "",
    lastName: "Haley",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-10-10T08:46:07.077",
    email: "kerihaley@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "55f17757-9754-4d9f-ba7b-cdbb887fad48",
    firstName: "Estes",
    infix: "",
    lastName: "Hopkins",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-11-14T12:31:56.5656",
    email: "esteshopkins@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "258fcdc4-c822-458c-9c4d-934ff6d48166",
    firstName: "Aurelia",
    infix: "",
    lastName: "Blake",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-01-06T10:07:54.5454",
    email: "aureliablake@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "26fddf6e-4d32-4ec6-9777-bcc8ac32d568",
    firstName: "Britney",
    infix: "",
    lastName: "Savage",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-31T05:08:11.1111",
    email: "britneysavage@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ebb01441-c225-43e8-8c1b-b53a4f304854",
    firstName: "Beatrice",
    infix: "",
    lastName: "Bray",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-04-14T06:56:14.1414",
    email: "beatricebray@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d856aca0-e6c9-4667-a7a4-1c29688215ab",
    firstName: "Nicholson",
    infix: "",
    lastName: "Short",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-16T07:20:33.3333",
    email: "nicholsonshort@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "32f461c3-e2cb-45f6-b7a6-d26159372440",
    firstName: "Foster",
    infix: "",
    lastName: "Roy",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-28T09:48:02.022",
    email: "fosterroy@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a06cab35-370f-4a36-a340-5a3cd380cd59",
    firstName: "Roberts",
    infix: "",
    lastName: "Hutchinson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-27T06:01:18.1818",
    email: "robertshutchinson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0ec3ba81-34ea-4f24-975a-2f7e1973a790",
    firstName: "Maryann",
    infix: "",
    lastName: "Ross",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-01-10T01:08:04.044",
    email: "maryannross@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8c45dcdd-8630-4544-b904-a677167eaf10",
    firstName: "Merle",
    infix: "",
    lastName: "Allen",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-15T01:11:36.3636",
    email: "merleallen@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "fcebda0c-18a8-4bd9-9aff-e81b70c16fd8",
    firstName: "Kristie",
    infix: "",
    lastName: "Goff",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-03-30T07:11:18.1818",
    email: "kristiegoff@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f12a2ac5-b864-45a5-a35f-5030e08f45a6",
    firstName: "George",
    infix: "",
    lastName: "Palmer",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-01-31T06:56:57.5757",
    email: "georgepalmer@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "19b052c2-8c6e-48cc-ae19-8dfb6a4ad3b8",
    firstName: "Kirk",
    infix: "",
    lastName: "Wyatt",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-18T09:28:39.3939",
    email: "kirkwyatt@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "fa359db6-b04b-4b71-9a98-cbaf96eb5416",
    firstName: "Holmes",
    infix: "",
    lastName: "Mcintosh",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-03-25T04:14:10.1010",
    email: "holmesmcintosh@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "903b7c37-771d-497b-a9f3-bfc847d817f7",
    firstName: "Janie",
    infix: "",
    lastName: "Shaw",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-10-11T10:17:33.3333",
    email: "janieshaw@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a6eb9965-fff7-406e-a1f2-1f180666f8ce",
    firstName: "Viola",
    infix: "",
    lastName: "Patton",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-02-25T01:35:49.4949",
    email: "violapatton@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "71bbf1da-47d1-44f4-bee3-0fb5c98c4d34",
    firstName: "Gamble",
    infix: "",
    lastName: "Santana",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-01-02T07:07:23.2323",
    email: "gamblesantana@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "87286606-3a48-4e4f-b74d-cbbb741cd622",
    firstName: "Rosario",
    infix: "",
    lastName: "Daniel",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-02T01:19:19.1919",
    email: "rosariodaniel@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6f8cad81-0c85-4469-a69e-762e3e5b8d82",
    firstName: "Heidi",
    infix: "",
    lastName: "Owens",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-03-01T11:04:40.4040",
    email: "heidiowens@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7e899834-fb3e-44e5-b65e-0d5fd757a09a",
    firstName: "Whitfield",
    infix: "",
    lastName: "Velasquez",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-02-18T08:36:56.5656",
    email: "whitfieldvelasquez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "fd9d37ec-7dbd-4e95-a503-159d37003d31",
    firstName: "Mary",
    infix: "",
    lastName: "Rios",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-24T01:40:59.5959",
    email: "maryrios@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ffeac537-5c5e-4a98-bc76-e6161f606ebf",
    firstName: "Rhodes",
    infix: "",
    lastName: "Ayers",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-11-08T06:23:24.2424",
    email: "rhodesayers@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "24a0d7c9-2812-4357-9e47-6c990964b750",
    firstName: "Kristin",
    infix: "",
    lastName: "Watson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-02-28T09:36:40.4040",
    email: "kristinwatson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6c449b6c-e671-4823-8af7-61a9c208c582",
    firstName: "Vera",
    infix: "",
    lastName: "Goodwin",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-03-14T05:36:03.033",
    email: "veragoodwin@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0ff4ec1e-d340-4085-8df0-f828fd9ecfff",
    firstName: "Patrica",
    infix: "",
    lastName: "Johns",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-05-26T11:36:25.2525",
    email: "patricajohns@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "cb59aed4-b54f-4cdd-bdb0-7aea1da041a4",
    firstName: "Brianna",
    infix: "",
    lastName: "Pittman",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-03-20T01:27:26.2626",
    email: "briannapittman@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "aa5e99e7-102c-4418-a7ef-92df18b7cf87",
    firstName: "Cleveland",
    infix: "",
    lastName: "Brennan",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-05-13T07:45:34.3434",
    email: "clevelandbrennan@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5a43a6d9-154e-450f-8305-9b5cac60ea5c",
    firstName: "Sanford",
    infix: "",
    lastName: "Whitfield",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-03-01T04:38:18.1818",
    email: "sanfordwhitfield@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c24603ec-4aef-4ccc-8d3c-f54b08c6b4a2",
    firstName: "Isabella",
    infix: "",
    lastName: "Nunez",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-01T05:17:45.4545",
    email: "isabellanunez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "18d4ab83-c66d-4eb8-b1a3-adbad98877b2",
    firstName: "Lee",
    infix: "",
    lastName: "Ramirez",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-02-23T01:32:03.033",
    email: "leeramirez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "da12b23e-4586-44e2-bc39-317b6a7372a8",
    firstName: "Fry",
    infix: "",
    lastName: "Byers",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-02-23T12:14:40.4040",
    email: "frybyers@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bbef387a-9f1d-4ce1-9826-96356238aacf",
    firstName: "Margery",
    infix: "",
    lastName: "Chavez",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-01-31T12:08:00.000",
    email: "margerychavez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f697b2db-fb51-470b-83c3-8967121b84e9",
    firstName: "Rollins",
    infix: "",
    lastName: "Mckay",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-01-13T11:50:07.077",
    email: "rollinsmckay@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4e8bc53e-c4e7-4342-864b-c440c14a79c0",
    firstName: "Zelma",
    infix: "",
    lastName: "Lawson",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-04-09T05:30:13.1313",
    email: "zelmalawson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "57e9625c-c5f9-4871-b354-0ea9afd44859",
    firstName: "Cannon",
    infix: "",
    lastName: "Bass",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-09-08T05:35:21.2121",
    email: "cannonbass@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9f9f49d4-c80c-424e-b0bc-074384cf3423",
    firstName: "Malinda",
    infix: "",
    lastName: "Farmer",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-15T05:15:42.4242",
    email: "malindafarmer@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8f25ec40-859a-4126-99e1-0b50d79a5e84",
    firstName: "Oneal",
    infix: "",
    lastName: "Walters",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-03-16T05:21:04.044",
    email: "onealwalters@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5b08f3bc-0949-41cb-96bd-4c5f805b9f72",
    firstName: "Jennie",
    infix: "",
    lastName: "Hayden",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-21T07:29:45.4545",
    email: "jenniehayden@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "07123bd8-653e-4a0b-b3a5-54d70a32dac0",
    firstName: "Katharine",
    infix: "",
    lastName: "Clayton",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-08-27T09:37:27.2727",
    email: "katharineclayton@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4b943bb3-db15-40a2-b2f5-5e3dbb43816e",
    firstName: "Grace",
    infix: "",
    lastName: "Cooke",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-02-07T10:46:52.5252",
    email: "gracecooke@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 1),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7cc6251c-33ee-45e5-87b4-9fcbb252c9ce",
    firstName: "Fowler",
    infix: "",
    lastName: "Meyers",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-07-20T09:35:27.2727",
    email: "fowlermeyers@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "89ce465f-d837-46aa-ab65-94a1c07c4ee2",
    firstName: "Hess",
    infix: "",
    lastName: "Vance",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-03-08T10:40:29.2929",
    email: "hessvance@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e5995f0f-2c31-44ae-bc06-3451831b843b",
    firstName: "Riley",
    infix: "",
    lastName: "Fuentes",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-04-03T07:11:30.3030",
    email: "rileyfuentes@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d106cc42-0430-43b9-835d-1a4994da038b",
    firstName: "Spears",
    infix: "",
    lastName: "Poole",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-07-12T11:23:56.5656",
    email: "spearspoole@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4f780390-5019-40dc-8111-23e61dc695b9",
    firstName: "Natalia",
    infix: "",
    lastName: "Robertson",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-07T12:29:48.4848",
    email: "nataliarobertson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "89566bc4-bd7c-48c0-996c-55c2e58e2b3b",
    firstName: "Duncan",
    infix: "",
    lastName: "Guerrero",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-05-10T03:03:07.077",
    email: "duncanguerrero@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a7f0266c-5789-4bda-b69f-ef599a02fea5",
    firstName: "Shaw",
    infix: "",
    lastName: "Vinson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-07-16T09:42:04.044",
    email: "shawvinson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "dbb1df68-d3a3-46d6-9177-b2bf8c8d077c",
    firstName: "Jean",
    infix: "",
    lastName: "Spears",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-02-21T11:01:39.3939",
    email: "jeanspears@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "b06721df-7b4a-4432-b1ae-1228069572d0",
    firstName: "Vilma",
    infix: "",
    lastName: "Fitzgerald",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-12-30T01:24:41.4141",
    email: "vilmafitzgerald@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c4ae9c61-7a3c-4849-b7f6-1aa9600dbe3f",
    firstName: "Contreras",
    infix: "",
    lastName: "Knox",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-19T12:41:04.044",
    email: "contrerasknox@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7e44128f-2b04-4f50-b4d4-1768e58d46b8",
    firstName: "Cantu",
    infix: "",
    lastName: "Ward",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-09-21T05:14:15.1515",
    email: "cantuward@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "81ea1643-6a9f-41d7-af88-85a5e3c6d95b",
    firstName: "Marshall",
    infix: "",
    lastName: "Arnold",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-01-30T01:44:38.3838",
    email: "marshallarnold@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "05409a9c-8e58-4f6a-ab8a-4a7836056fa8",
    firstName: "Leach",
    infix: "",
    lastName: "Dawson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-02-07T10:58:32.3232",
    email: "leachdawson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a251bfc3-ea9a-4d45-aeac-9b7a0fd2680b",
    firstName: "Farmer",
    infix: "",
    lastName: "Lawrence",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-03-31T07:42:41.4141",
    email: "farmerlawrence@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bf90b732-52a8-45c6-b0a4-2cb888aefdf0",
    firstName: "Angelique",
    infix: "",
    lastName: "Morton",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-11-06T08:57:57.5757",
    email: "angeliquemorton@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "b9d7be4a-2772-4b6e-b437-c3ceb1eb956d",
    firstName: "Meagan",
    infix: "",
    lastName: "Kelly",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-25T12:09:34.3434",
    email: "meagankelly@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5e2e1a73-cf6e-42ab-846a-21a392ad44d4",
    firstName: "Rebecca",
    infix: "",
    lastName: "Wilkins",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-08-26T10:43:06.066",
    email: "rebeccawilkins@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7a776d53-32f9-4250-bdec-71865a9a1f6c",
    firstName: "Lottie",
    infix: "",
    lastName: "Levine",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-04-03T05:28:33.3333",
    email: "lottielevine@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "33857357-857d-4033-8087-6a3bd9c21a25",
    firstName: "Jacobson",
    infix: "",
    lastName: "Pate",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-26T11:21:06.066",
    email: "jacobsonpate@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "cfb0cae2-b541-4e6c-a87c-478b8a03d42f",
    firstName: "Ines",
    infix: "",
    lastName: "Conner",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-06-02T03:39:53.5353",
    email: "inesconner@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "640b092e-3d8d-4828-9b7b-bac03e243413",
    firstName: "Burns",
    infix: "",
    lastName: "Norris",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-07-22T08:03:20.2020",
    email: "burnsnorris@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "beca1d78-cfe9-4b22-8e94-75b82d4efab8",
    firstName: "Blackwell",
    infix: "",
    lastName: "Langley",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-07-15T03:23:07.077",
    email: "blackwelllangley@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "07e73b16-aa10-4c90-b167-39c2290df79a",
    firstName: "Vaughn",
    infix: "",
    lastName: "Mercado",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-09-24T02:07:37.3737",
    email: "vaughnmercado@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0f626afe-1d8f-4f43-a528-08fc94dd5730",
    firstName: "Bond",
    infix: "",
    lastName: "Booth",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-02-04T07:54:21.2121",
    email: "bondbooth@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "41dcd8af-c448-413a-bd63-a5ff903bec22",
    firstName: "Mcguire",
    infix: "",
    lastName: "English",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-08T04:20:07.077",
    email: "mcguireenglish@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "de37e25e-527d-4e71-8505-3a4da95d20f6",
    firstName: "Frank",
    infix: "",
    lastName: "Diaz",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-05T04:20:29.2929",
    email: "frankdiaz@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c6a4515e-1db3-4e76-9660-1a85e5ed63ed",
    firstName: "Ina",
    infix: "",
    lastName: "Zimmerman",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-23T02:21:00.000",
    email: "inazimmerman@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4bdcb79c-7a7d-4517-85a0-f14057d4f915",
    firstName: "Naomi",
    infix: "",
    lastName: "Talley",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2024-03-08T04:12:28.2828",
    email: "naomitalley@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f2660a9a-afe4-421a-b9ef-42f06b7c1433",
    firstName: "Bridgette",
    infix: "",
    lastName: "Murray",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-16T02:55:50.5050",
    email: "bridgettemurray@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "95d93f79-663c-42ef-9480-a11f48513134",
    firstName: "Gentry",
    infix: "",
    lastName: "Guy",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-11-15T07:12:33.3333",
    email: "gentryguy@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d6099312-e294-4484-bd4f-858b084668ba",
    firstName: "Aisha",
    infix: "",
    lastName: "Brady",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-01-23T01:49:04.044",
    email: "aishabrady@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "07497938-6b21-435c-b3c2-b05161c0720a",
    firstName: "Mejia",
    infix: "",
    lastName: "Gallagher",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-03T02:05:50.5050",
    email: "mejiagallagher@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "49558bc6-f207-49dc-b8f4-80897d743d36",
    firstName: "Ava",
    infix: "",
    lastName: "Nielsen",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-03-01T12:24:09.099",
    email: "avanielsen@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "b3547d15-ca5e-478f-82fd-31f83f85b97d",
    firstName: "Holt",
    infix: "",
    lastName: "Hale",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-12-31T05:20:23.2323",
    email: "holthale@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "2d9b6346-3de1-4d2b-aadd-25ff026d8d89",
    firstName: "Jimmie",
    infix: "",
    lastName: "Gibbs",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-11-26T12:06:23.2323",
    email: "jimmiegibbs@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0da4d5f8-ea74-4ddf-b8b5-924d4638ed1a",
    firstName: "Christensen",
    infix: "",
    lastName: "Sandoval",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-06-24T08:28:26.2626",
    email: "christensensandoval@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "890d7215-1b96-4f73-8bec-2d2679863351",
    firstName: "Ginger",
    infix: "",
    lastName: "Jackson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-07-25T11:13:28.2828",
    email: "gingerjackson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f06d5115-f731-486a-9dc4-9be9811762a4",
    firstName: "Graciela",
    infix: "",
    lastName: "Sullivan",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2023-04-03T05:48:26.2626",
    email: "gracielasullivan@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9737cda5-9bb1-4542-91c0-d99c2286b4df",
    firstName: "Lamb",
    infix: "",
    lastName: "Hanson",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-02-20T03:17:45.4545",
    email: "lambhanson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5530e2bd-819b-4bc0-a7de-e6a89d9efb82",
    firstName: "Huber",
    infix: "",
    lastName: "Fuller",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-23T01:17:04.044",
    email: "huberfuller@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "172a366d-12ef-40ff-9f30-9048725866ad",
    firstName: "Luisa",
    infix: "",
    lastName: "Henry",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-27T12:21:00.000",
    email: "luisahenry@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "51bab9b8-5bc3-409d-b7e1-7b5eb9acff1c",
    firstName: "Bates",
    infix: "",
    lastName: "Mcmahon",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-01-06T07:57:40.4040",
    email: "batesmcmahon@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8ccbd85b-0c80-45f9-b77f-f6acab3c8335",
    firstName: "Miranda",
    infix: "",
    lastName: "Wilder",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-01-30T07:18:30.3030",
    email: "mirandawilder@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "599a39ea-8c4f-44bc-9820-8d9548f05483",
    firstName: "Dona",
    infix: "",
    lastName: "Glass",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-08-25T01:43:48.4848",
    email: "donaglass@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a380bd1d-c131-4c77-bcbd-842200b3b948",
    firstName: "Parker",
    infix: "",
    lastName: "Mccoy",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-04T06:58:24.2424",
    email: "parkermccoy@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ba1603dd-3e69-4671-b8fa-7c8f8106119b",
    firstName: "Fanny",
    infix: "",
    lastName: "Bush",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-09-15T08:44:18.1818",
    email: "fannybush@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7d462bb1-2a5e-4c67-8612-836e4e5d3454",
    firstName: "Jessica",
    infix: "",
    lastName: "Whitehead",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-10-09T02:49:32.3232",
    email: "jessicawhitehead@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c15063c7-66ea-4a2c-b6d9-bcb80162ae2c",
    firstName: "Ida",
    infix: "",
    lastName: "Dale",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-09-21T11:55:31.3131",
    email: "idadale@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f24d1f1e-06f8-43db-81ce-36b999be1fa7",
    firstName: "Lauren",
    infix: "",
    lastName: "Bell",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-08-13T11:38:47.4747",
    email: "laurenbell@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "556d3459-0eaf-4392-a766-32da426261bc",
    firstName: "Candace",
    infix: "",
    lastName: "Mills",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-08-21T02:18:46.4646",
    email: "candacemills@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f882ecd9-a1e2-4030-b163-821ec2c72a62",
    firstName: "Drake",
    infix: "",
    lastName: "Olson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-26T04:21:11.1111",
    email: "drakeolson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3bbbdb96-ca4b-40c5-aebc-ee254126f639",
    firstName: "Humphrey",
    infix: "",
    lastName: "Keller",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-03T03:18:24.2424",
    email: "humphreykeller@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "b49a252f-15d9-4fa3-87a9-f3956d5c137a",
    firstName: "Barr",
    infix: "",
    lastName: "Morris",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-23T08:48:46.4646",
    email: "barrmorris@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1a9dea91-3980-49c3-8acd-53e73384732e",
    firstName: "Figueroa",
    infix: "",
    lastName: "Blackburn",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-05-24T12:27:37.3737",
    email: "figueroablackburn@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4da376d5-7ac3-455d-a330-eebfe7891de3",
    firstName: "Holland",
    infix: "",
    lastName: "Mason",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-25T08:31:44.4444",
    email: "hollandmason@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8cb3853c-a0ab-4abc-9313-997d7dfe9651",
    firstName: "Paige",
    infix: "",
    lastName: "Rodriguez",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-09-03T08:41:09.099",
    email: "paigerodriguez@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "71f14e78-3534-4319-9d34-f3c0e2018a60",
    firstName: "Crystal",
    infix: "",
    lastName: "Harrell",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-15T04:30:04.044",
    email: "crystalharrell@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ee441e1e-b78c-43fd-a0d5-96ad529e0569",
    firstName: "Byrd",
    infix: "",
    lastName: "Hess",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-07-16T10:41:58.5858",
    email: "byrdhess@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "30acb562-05ca-4216-b922-c4cad40e5dfa",
    firstName: "Millicent",
    infix: "",
    lastName: "Branch",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-23T04:58:31.3131",
    email: "millicentbranch@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d9dc88b8-0750-40ef-9553-55df0f4514f3",
    firstName: "Hilary",
    infix: "",
    lastName: "Fry",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-04-20T07:13:40.4040",
    email: "hilaryfry@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bef5b66f-3fcd-4db8-ab53-a0b606321b5f",
    firstName: "Miller",
    infix: "",
    lastName: "Cain",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-07T07:49:15.1515",
    email: "millercain@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6463e84d-d6b3-4816-a673-f5887f798856",
    firstName: "Craft",
    infix: "",
    lastName: "Boyd",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-12-17T04:25:39.3939",
    email: "craftboyd@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "96d2f529-76ce-40f6-b095-8de6942c2399",
    firstName: "Willa",
    infix: "",
    lastName: "Hurley",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-29T08:25:02.022",
    email: "willahurley@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "81242ab3-2b4e-4e8d-bbcd-45dfdc97a303",
    firstName: "Cote",
    infix: "",
    lastName: "Mcclain",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-08-23T10:14:52.5252",
    email: "cotemcclain@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3042b99a-6a20-453c-b3de-2b9819299704",
    firstName: "Frances",
    infix: "",
    lastName: "Zamora",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-20T10:26:22.2222",
    email: "franceszamora@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "24ad15ad-318a-43eb-8cdd-290843f7f1a4",
    firstName: "Ora",
    infix: "",
    lastName: "Preston",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2025-03-22T06:35:24.2424",
    email: "orapreston@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "79bb4697-9a93-4be1-bbdc-e770f786b661",
    firstName: "Elisabeth",
    infix: "",
    lastName: "Mcdaniel",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-08-13T06:25:04.044",
    email: "elisabethmcdaniel@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "eb7c84cb-3a61-4539-86db-9e12ea7d2b30",
    firstName: "Aileen",
    infix: "",
    lastName: "Mcfadden",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-06-24T12:18:19.1919",
    email: "aileenmcfadden@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "918ef992-4dd3-4d49-b9ef-170a394a470d",
    firstName: "Maldonado",
    infix: "",
    lastName: "Randolph",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-01-15T11:08:11.1111",
    email: "maldonadorandolph@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "13e08135-7f64-4e23-9b95-af0dabe10b2c",
    firstName: "Lois",
    infix: "",
    lastName: "Mendez",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-28T05:31:44.4444",
    email: "loismendez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c830436a-d7a2-4833-bdcb-04a13b0b0da2",
    firstName: "Maddox",
    infix: "",
    lastName: "Mejia",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-20T01:47:16.1616",
    email: "maddoxmejia@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bffd1b1d-9cf6-4736-9fe9-f280d37f4496",
    firstName: "Villarreal",
    infix: "",
    lastName: "Chaney",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-12-25T10:35:53.5353",
    email: "villarrealchaney@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4e69f8c2-82d4-4b79-b0c5-aca65336051c",
    firstName: "Gray",
    infix: "",
    lastName: "Garza",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-07-06T12:15:16.1616",
    email: "graygarza@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "82a3a8a2-d7b0-4866-bbdc-f31060bc7166",
    firstName: "Mcneil",
    infix: "",
    lastName: "Heath",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-10T09:17:00.000",
    email: "mcneilheath@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9f885485-0f36-4e71-a65e-2d71642e8c69",
    firstName: "Miranda",
    infix: "",
    lastName: "Atkinson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2025-01-01T05:48:48.4848",
    email: "mirandaatkinson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "77431cac-e617-43a2-a38d-81879f32b4c1",
    firstName: "Desiree",
    infix: "",
    lastName: "Guthrie",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-12-14T07:59:05.055",
    email: "desireeguthrie@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c86bad18-f624-462c-9e9a-b8b0d76c005a",
    firstName: "Faye",
    infix: "",
    lastName: "Rivers",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-02-02T01:55:03.033",
    email: "fayerivers@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ed83c499-f622-46c8-9dc8-babb7f1c7ddf",
    firstName: "Alford",
    infix: "",
    lastName: "Houston",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-29T10:28:57.5757",
    email: "alfordhouston@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "2b773280-9373-4b13-bac3-645cd995815f",
    firstName: "Blanca",
    infix: "",
    lastName: "Ingram",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-11-29T05:35:31.3131",
    email: "blancaingram@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4e21083f-c098-4b5d-b6ad-2b4629415db9",
    firstName: "Chan",
    infix: "",
    lastName: "Johnston",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-07-17T05:59:04.044",
    email: "chanjohnston@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6692ca61-22e4-41ee-84ff-49bf79bf511a",
    firstName: "Torres",
    infix: "",
    lastName: "Holt",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-08-13T08:42:44.4444",
    email: "torresholt@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4514e24a-0f78-409c-a9ea-6736f9815f43",
    firstName: "Lora",
    infix: "",
    lastName: "Mcneil",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-07-18T08:25:44.4444",
    email: "loramcneil@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8e0162fe-cbdd-4eb8-99bc-d57a424b6efd",
    firstName: "Karyn",
    infix: "",
    lastName: "Kelley",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-05-10T05:20:07.077",
    email: "karynkelley@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0183a9fd-c78b-4007-9c18-ca973b4f30c0",
    firstName: "Potter",
    infix: "",
    lastName: "Parsons",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-10-21T08:22:38.3838",
    email: "potterparsons@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d65865c9-98b7-4d73-bb2a-1dc577355716",
    firstName: "Julia",
    infix: "",
    lastName: "Oconnor",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-01-30T10:35:57.5757",
    email: "juliaoconnor@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "13397fd3-d9b3-4ef2-b2a3-07f63b15004e",
    firstName: "Sue",
    infix: "",
    lastName: "Welch",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-03-15T04:18:36.3636",
    email: "suewelch@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3db67187-317e-431e-b64b-9938fbab82ad",
    firstName: "Winnie",
    infix: "",
    lastName: "Lang",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-12-04T12:33:48.4848",
    email: "winnielang@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "dbba9acd-c8f9-44fb-b064-8a026cff4be5",
    firstName: "Kenya",
    infix: "",
    lastName: "Mcpherson",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-12T12:37:22.2222",
    email: "kenyamcpherson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "47f00a0c-b07c-46c8-a620-658128d86f20",
    firstName: "Mcdonald",
    infix: "",
    lastName: "Powers",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-01-02T08:01:02.022",
    email: "mcdonaldpowers@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "efe2bfde-3cec-4d9b-9899-7d081a95d99f",
    firstName: "Lucas",
    infix: "",
    lastName: "Cruz",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-01-16T04:43:42.4242",
    email: "lucascruz@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "35e99f41-9f33-4936-a909-748ef5623f95",
    firstName: "Eddie",
    infix: "",
    lastName: "Beach",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-07-18T09:33:24.2424",
    email: "eddiebeach@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e1b1ebb7-c84d-49b9-82a3-2970fbedd1c4",
    firstName: "Sharon",
    infix: "",
    lastName: "Peterson",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-01-03T04:08:42.4242",
    email: "sharonpeterson@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7877f128-927a-4763-bb8c-03fb5582ff2e",
    firstName: "Bette",
    infix: "",
    lastName: "Hancock",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2023-03-25T02:54:01.011",
    email: "bettehancock@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ccf09833-5272-4445-8a1b-11af87cb142c",
    firstName: "Ward",
    infix: "",
    lastName: "Chandler",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-08-09T04:24:01.011",
    email: "wardchandler@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "74b614e7-5da3-4ef6-9089-97e5fee1d91f",
    firstName: "Bender",
    infix: "",
    lastName: "Mcleod",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-10-20T03:24:56.5656",
    email: "bendermcleod@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1264e1d2-fbe8-4e24-aad2-6b15814a05e1",
    firstName: "Marianne",
    infix: "",
    lastName: "Schneider",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-04-08T03:10:35.3535",
    email: "marianneschneider@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1f2af80d-8afc-4b81-98af-49e72468b647",
    firstName: "Wheeler",
    infix: "",
    lastName: "Shaffer",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-09-10T07:53:49.4949",
    email: "wheelershaffer@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "8e9a5ea0-1367-44cf-a448-65cbefa78393",
    firstName: "Golden",
    infix: "",
    lastName: "Huffman",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-09-04T07:03:31.3131",
    email: "goldenhuffman@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f142f99c-6368-4b8f-92e9-f4e14a120452",
    firstName: "Christian",
    infix: "",
    lastName: "David",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-01-05T12:59:25.2525",
    email: "christiandavid@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f22982cc-9c7e-4a48-b5f1-7a7ae0c4f48c",
    firstName: "Yesenia",
    infix: "",
    lastName: "Walker",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-03T02:58:48.4848",
    email: "yeseniawalker@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "28fabdc9-565f-40c4-bd70-898d0eafd5e1",
    firstName: "Addie",
    infix: "",
    lastName: "Payne",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-02-24T05:36:41.4141",
    email: "addiepayne@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "475408b4-8224-40a0-b52f-dd440730625d",
    firstName: "Minerva",
    infix: "",
    lastName: "Albert",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-12-14T03:15:26.2626",
    email: "minervaalbert@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "76cc27a5-f59f-4b92-8d4b-3fdfb0bfe403",
    firstName: "Hancock",
    infix: "",
    lastName: "Stevens",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-08-26T01:59:03.033",
    email: "hancockstevens@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "9731721f-c8e9-4a18-8ed7-b7d4d9d7a2d4",
    firstName: "Mckee",
    infix: "",
    lastName: "Harrison",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-28T04:03:45.4545",
    email: "mckeeharrison@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3ad217a0-ca68-4c81-9828-50f0af6bf1ac",
    firstName: "Jacquelyn",
    infix: "",
    lastName: "Snow",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-08-11T04:44:35.3535",
    email: "jacquelynsnow@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "01ece06e-4eda-466b-80a7-3890703182bb",
    firstName: "Sabrina",
    infix: "",
    lastName: "Adams",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-11-07T05:43:40.4040",
    email: "sabrinaadams@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "383dd814-65f5-4020-97a5-0201901ce981",
    firstName: "Gracie",
    infix: "",
    lastName: "Rush",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-05-25T08:48:45.4545",
    email: "gracierush@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1877d92d-e64b-4b64-93aa-2dc7b32e06f9",
    firstName: "Santana",
    infix: "",
    lastName: "Solomon",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-06-12T02:33:27.2727",
    email: "santanasolomon@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bd1fbf56-5d68-4ffe-a8c2-d9cad5826585",
    firstName: "Aimee",
    infix: "",
    lastName: "Jennings",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-08-06T02:16:31.3131",
    email: "aimeejennings@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3a1cc561-abc6-4f32-9144-1eb0915622dc",
    firstName: "Casey",
    infix: "",
    lastName: "Pugh",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-01-06T07:01:11.1111",
    email: "caseypugh@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d9d3bb4b-47e7-47a4-8c91-6f4fca319ec9",
    firstName: "Cecilia",
    infix: "",
    lastName: "Duran",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-27T02:38:00.000",
    email: "ceciliaduran@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "eca76c5a-a47f-4e80-9e10-e7edf63830d6",
    firstName: "Sweeney",
    infix: "",
    lastName: "Shelton",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-07-15T07:10:00.000",
    email: "sweeneyshelton@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4ab116e6-2e8a-4461-ad9d-615f56c30513",
    firstName: "Stacie",
    infix: "",
    lastName: "Chang",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-03-11T04:30:44.4444",
    email: "staciechang@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d9a68149-e0a2-4dee-abac-59321939ac9d",
    firstName: "Payne",
    infix: "",
    lastName: "Church",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-11-22T09:12:04.044",
    email: "paynechurch@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "424663af-c357-42d3-8ca0-30105e4c89b9",
    firstName: "Therese",
    infix: "",
    lastName: "Hood",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-29T11:20:27.2727",
    email: "theresehood@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(1, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "dadbcc2a-3a7a-4b30-83c2-5aaef83e4c4d",
    firstName: "Kimberley",
    infix: "",
    lastName: "Ashley",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-12-25T11:57:46.4646",
    email: "kimberleyashley@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 9),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e4305f52-c1e4-46c8-8abc-bee79e491082",
    firstName: "Cochran",
    infix: "",
    lastName: "Avila",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-14T03:58:55.5555",
    email: "cochranavila@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "73516cd0-8d46-4ceb-a6df-e22443db2ca4",
    firstName: "Eugenia",
    infix: "",
    lastName: "Stuart",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-05T04:20:04.044",
    email: "eugeniastuart@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "5adb9254-0944-4133-9fb5-c6651bd7db27",
    firstName: "Tamara",
    infix: "",
    lastName: "Orr",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-10-05T02:24:01.011",
    email: "tamaraorr@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 4),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "ab9c520e-441f-4c1c-a81c-021d9db5dc79",
    firstName: "Lopez",
    infix: "",
    lastName: "Hansen",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2023-03-14T11:23:15.1515",
    email: "lopezhansen@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "6fd4a4ca-a4e5-4c67-85c0-61cb6f8dfebb",
    firstName: "Lawson",
    infix: "",
    lastName: "Fleming",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-01-25T03:35:50.5050",
    email: "lawsonfleming@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "a47cc912-d509-4cbe-bec6-7c9b3277b4a4",
    firstName: "Bridges",
    infix: "",
    lastName: "Hines",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-05-17T06:49:17.1717",
    email: "bridgeshines@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "de63aa7a-5720-4a4b-a0f9-3f835590b5f1",
    firstName: "Mooney",
    infix: "",
    lastName: "Meyer",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2023-01-20T12:01:16.1616",
    email: "mooneymeyer@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "3c289881-2c67-4d34-acf2-192d247e3799",
    firstName: "Allyson",
    infix: "",
    lastName: "Mathis",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-05-26T12:57:28.2828",
    email: "allysonmathis@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(3, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "d0e3af41-daaa-462a-acf8-9646bfd9f80e",
    firstName: "Fisher",
    infix: "",
    lastName: "Holcomb",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-04-01T03:33:42.4242",
    email: "fisherholcomb@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 2),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "e15bdc29-5f6b-40e0-9e2e-7c8ab2154ca8",
    firstName: "Trevino",
    infix: "",
    lastName: "Gomez",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-01-24T05:26:43.4343",
    email: "trevinogomez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(8, 10),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "4e142922-ab6a-4479-8df0-6078f201a269",
    firstName: "Brandie",
    infix: "",
    lastName: "Barnett",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2023-02-25T06:04:03.033",
    email: "brandiebarnett@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(0, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "0b2f7138-2bc6-4462-b70a-6a353e460004",
    firstName: "Patton",
    infix: "",
    lastName: "Clements",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-02-20T06:58:15.1515",
    email: "pattonclements@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "7ac3c9a6-69cc-43c1-97e6-90918b3eaeb8",
    firstName: "Ramos",
    infix: "",
    lastName: "Waters",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-07-28T12:52:23.2323",
    email: "ramoswaters@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "1ec131e4-e371-44c8-bec3-ecd5ff812686",
    firstName: "Elvira",
    infix: "",
    lastName: "Cherry",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-06-27T12:14:12.1212",
    email: "elviracherry@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(5, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "478afe6a-efb1-4577-a9d2-2c3e84e788bf",
    firstName: "Willis",
    infix: "",
    lastName: "Graves",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2024-10-31T03:24:19.1919",
    email: "willisgraves@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "bf22475b-c998-465f-98ad-06fa4dc58598",
    firstName: "Kitty",
    infix: "",
    lastName: "Cortez",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-03-26T02:53:25.2525",
    email: "kittycortez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 5),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "127431c0-cac3-454c-b965-ec1833d4b3de",
    firstName: "Anne",
    infix: "",
    lastName: "Logan",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2023-08-02T10:54:19.1919",
    email: "annelogan@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "361a487d-28a6-4fb9-b0f6-7d88795eaafd",
    firstName: "Mercado",
    infix: "",
    lastName: "Mcdowell",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-11-28T04:33:20.2020",
    email: "mercadomcdowell@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "f7d4a1be-8022-4b85-9c38-0e5c923df3a5",
    firstName: "Diaz",
    infix: "",
    lastName: "Espinoza",
    title: "",
    language: "NL" as Language,
    status: "inactive" as UserStatus,
    created: "2023-11-22T12:36:11.1111",
    email: "diazespinoza@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "24500e82-deda-46ed-9f98-2cc54ac19549",
    firstName: "Lorrie",
    infix: "",
    lastName: "Nicholson",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-09-15T06:25:03.033",
    email: "lorrienicholson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 7),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "85ff0f98-f49b-479a-bb79-ee39ace0ad6a",
    firstName: "Deanne",
    infix: "",
    lastName: "Perez",
    title: "",
    language: "EN" as Language,
    status: "inactive" as UserStatus,
    created: "2024-04-20T12:01:59.5959",
    email: "deanneperez@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(6, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "2e03b97e-25f8-450e-81c4-6f4598cf32fc",
    firstName: "Kathy",
    infix: "",
    lastName: "Contreras",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-01-27T02:14:57.5757",
    email: "kathycontreras@demo.workplaced.com",
    isFavorite: false,
    userGroups: [],
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "c776cd4a-0f83-46ac-8262-0bca81d0b1be",
    firstName: "Acosta",
    infix: "",
    lastName: "Reilly",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2025-02-24T12:05:39.3939",
    email: "acostareilly@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(2, 3),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "def47e1b-54fa-4585-b19e-d5e4f95c296b",
    firstName: "Carly",
    infix: "",
    lastName: "Britt",
    title: "",
    language: "EN" as Language,
    status: "active" as UserStatus,
    created: "2024-12-24T11:54:48.4848",
    email: "carlybritt@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(4, 6),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
  {
    id: "88363b5a-183a-41bb-a1e3-3906c2e3ff65",
    firstName: "Hansen",
    infix: "",
    lastName: "Johnson",
    title: "",
    language: "NL" as Language,
    status: "active" as UserStatus,
    created: "2024-10-27T01:08:58.5858",
    email: "hansenjohnson@demo.workplaced.com",
    isFavorite: false,
    userGroups: kUserGroups.slice(7, 8),
    ssoProviders: [],
    _operations: {
      canDelete: true,
      canUpdateName: true,
      canUpdateEmail: true,
    },
  },
];
